import { ApplicationConfig, inject, provideAppInitializer, provideZoneChangeDetection } from '@angular/core';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { provideRouter, Router, TitleStrategy, withInMemoryScrolling, withViewTransitions } from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideTranslateService, TranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { routes } from './app.routes';
import { errorInterceptor } from './core/interceptors/error.interceptor';
import { authInterceptor } from './core/interceptors/auth.interceptor';
import { TranslateTitleStrategy } from './core/i18n/translate-title.strategy';
import { configureTranslateInstant } from './core/i18n/translate-instant';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(
      routes,
      withInMemoryScrolling({
        scrollPositionRestoration: 'top',
        anchorScrolling: 'enabled',
      }),
      withViewTransitions({
        skipInitialTransition: true,
        onViewTransitionCreated: ({ transition }) => {
          const router = inject(Router);
          const targetUrl = router.getCurrentNavigation()?.finalUrl?.toString() ?? '';
          const currentUrl = router.url;

          if (targetUrl.includes('/auth') || currentUrl.includes('/auth')) {
            transition.skipTransition();
          }
        },
      })
    ),
    { provide: TitleStrategy, useClass: TranslateTitleStrategy },
    provideHttpClient(withFetch(), withInterceptors([authInterceptor, errorInterceptor])),
    provideAnimations(),
    provideTranslateService({
      fallbackLang: 'fr',
      lang: 'fr',
    }),
    // Load one locale JSON at a time (not both FR+EN bundled into main).
    // useHttpBackend: skip auth/error interceptors for static assets.
    ...provideTranslateHttpLoader({
      prefix: '/assets/i18n/',
      suffix: '.json',
      useHttpBackend: true,
    }),
    provideAppInitializer(() => {
      const translate = inject(TranslateService);
      configureTranslateInstant((key, params) => translate.instant(key, params));
    }),
  ],
};
